import { Box, Typography, Button, Snackbar } from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ja } from "date-fns/locale";
import { ManagementUsersStyle as styles } from "./ManagementUsersStyle";
import UserListTable from "../components/Table/UserListTable";
import { useManagementUsers } from "../hooks/logic/useManagementUsers";
import ManagementUsersDialog from "../components/ManagementUsersDialog";

const ManagementUsers = () => {
  const {
    inputRef,
    userList,
    selectedRow,
    checkedIds,
    handleCheckChange,
    handleUpdate,
    handleRowClick,
    detailDialogOpen,
    setDetailDialogOpen,
    toastOpen,
    toastMessage,
    toastSeverity,
    handleCloseToast,
    handleApprove,
    handleCancel,
    handleDelete,
    handleCheckChangeAll,
  } = useManagementUsers();
  const hasSelection = checkedIds.size > 0;
  const FOOTER_HEIGHT = 60;

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ja}>
      <ManagementUsersDialog
        open={detailDialogOpen}
        onClose={() => {
          // setSelectedParent(null);
          setDetailDialogOpen(false);
        }}
        statusId={4}
        userInfo={selectedRow!}
        onUpdate={handleUpdate}
      />
      <Box sx={styles.titleBar}>
        <Typography variant="h6" sx={styles.titleText}>
          ユーザーリスト
        </Typography>
      </Box>
      <Box py={0} px={0}>
        <Box mt={2}>
          <UserListTable
            users={userList}
            checkedIds={checkedIds}
            onCheckedChange={handleCheckChange}
            onCheckedChangeAll={handleCheckChangeAll}
            onRowClick={handleRowClick}
            footerHeight={FOOTER_HEIGHT}
          ></UserListTable>
        </Box>

        {/* チェック件数 & ボタンを下部に固定表示 */}
        {checkedIds.size > 0 && (
          <Box
            sx={{
              height: `${FOOTER_HEIGHT}px`,
              position: "fixed",
              bottom: 0,
              right: 0,
              width: "100%",
              bgcolor: "white",
              borderTop: "1px solid #ccc",
              p: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 1000,
            }}
          >
            <Box gap={2} sx={{ marginLeft: "240px" }}>
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <Typography>全{checkedIds.size}件選択されています</Typography>
              </Box>

              <Box display="flex" gap={2}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleApprove}
                >
                  承認する
                </Button>
                <Button variant="outlined" onClick={handleCancel}>
                  キャンセル
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  onClick={handleDelete}
                >
                  ユーザー削除
                </Button>
              </Box>
            </Box>
          </Box>
        )}
      </Box>
      <Snackbar
        open={toastOpen}
        autoHideDuration={4000}
        onClose={handleCloseToast}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          onClose={handleCloseToast}
          severity={toastSeverity}
          sx={{ width: "100%" }}
          elevation={6}
          variant="filled"
        >
          {toastMessage}
        </MuiAlert>
      </Snackbar>
    </LocalizationProvider>
  );
};

export default ManagementUsers;
